import CardActionArea from '@mui/material/CardActionArea';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import LazyLoad from 'react-lazyload';
import ProgressiveImage from 'react-progressive-image';
import { imageProxy } from 'tf-post-parser';
import shadow from '../../helpers/shadow';
import Link from '@mui/material/Link';

const placeholder = (
  <Skeleton variant="rectangular" width="100%" height={350} />
);

export default function CarouselLargeItem({ post, webpSupport }) {
  const imgSrc = imageProxy(
    post.thumbnail,
    1200,
    400,
    undefined,
    webpSupport ? 'webp' : undefined,
  );

  const useStyles = makeStyles()(() => ({
    img: {
      width: '100%',
      transition: 'all 0.5s',
      height: '350px',
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.1),rgba(0, 0, 0,0.3)), url("${imgSrc}")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
    imgContainer: {
      borderRadius: 8,
      height: '350px',
      width: '100%',
      overflow: 'hidden',
      position: 'relative',
      boxShadow: shadow.md,
    },
    heading: {
      textShadow: '1px 1px 20px #343A40',
      fontSize: 35,
    },
  }));

  const { classes } = useStyles();

  return (
    <div className="w-100">
      <Link
        color="textPrimary"
        href={`/@${post.author.username}/${post.permlink}`}
      >
        <div
          key={post.permlink}
          className="w-100"
          style={{ maxHeight: '350px' }}
        >
          <div className={classes.imgContainer}>
            <CardActionArea>
              <LazyLoad
                offset={100}
                height={250}
                once
                placeholder={placeholder}
              >
                <ProgressiveImage src={imgSrc} placeholder={placeholder}>
                  {(src, loading) => {
                    if (loading) {
                      return placeholder;
                    }
                    return (
                      <div className={classes.img}>
                        <div className="row h-100 w-100 m-0 text-center">
                          <div className="my-auto text-center w-100">
                            <Typography
                              variant="h5"
                              className={`${classes.heading} text-light font-weight-bold`}
                            >
                              {post.title}
                            </Typography>
                          </div>
                        </div>
                      </div>
                    );
                  }}
                </ProgressiveImage>
              </LazyLoad>
            </CardActionArea>
          </div>
        </div>
      </Link>
    </div>
  );
}
